import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-page',
  templateUrl: './empty-page.component.html',
  styleUrls: ['./empty-page.component.scss']
})
export class EmptyPageComponent implements OnInit {

  @Input() entityName: string;
  @Input() listButton: boolean;
  constructor() { }

  ngOnInit(): void { }
}
